import React from "react";
import iconInstagram from "assets/img/newversion/IconInstagram.png";

function SocialIcons() {
  return (
    <div className="d-flex gap-2 justify-content-center align-items-center w-100">
      <style jsx>{`
        .social-icon {
          transition: opacity 0.3s ease;
        }
        .social-icon:hover {
          opacity: 0.8;
        }
        @media (max-width: 576px) {
          .social-icons-container {
            gap: 1rem;
          }
          .instagram-icon {
            width: 20px;
            height: 19px;
          }
        }
      `}</style>
      <a href="https://www.facebook.com/nacaosaudeapp" aria-label="Facebook" className="social-icon">
        <div
          dangerouslySetInnerHTML={{
            __html:
              `<svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="facebook-icon" style="width: 21px; height: 21px">
                <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.312h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0" fill="white"/>
              </svg>`
          }}
        />
      </a>
      <div className="social-icons-container d-flex gap-2 justify-content-center align-items-center">
        <a href="https://www.instagram.com/nacaosaude/?hl=pt-br" aria-label="Instagram" className="social-icon">
          <img
            src={iconInstagram}
            alt="Instagram"
            className="instagram-icon"
            style={{ height: "21px", width: "22px" }}
          />
        </a>
        <a href="https://www.linkedin.com/company/nacaosaude/" aria-label="LinkedIn" className="social-icon">
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<svg id=\"I66:769;19:366\" layer-name=\"LinkedIn (icon — Colour)\" width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"linkedin-icon\" style=\"width: 24px; height: 24px\"> <path d=\"M19.5409 19.0414H16.5775V14.4004C16.5775 13.2938 16.5577 11.8691 15.0363 11.8691C13.4929 11.8691 13.2567 13.0749 13.2567 14.3199V19.0411H10.2933V9.49742H13.1382V10.8017H13.178C13.4627 10.3149 13.8741 9.91439 14.3684 9.64292C14.8627 9.37144 15.4213 9.23912 15.9849 9.26004C18.9883 9.26004 19.5422 11.2357 19.5422 13.8059L19.5409 19.0414ZM6.94968 8.19287C6.60956 8.19294 6.27704 8.09214 5.99422 7.90321C5.71137 7.7143 5.49093 7.44576 5.36071 7.13153C5.2305 6.81731 5.19638 6.47153 5.26267 6.13793C5.32896 5.80432 5.49269 5.49786 5.73316 5.25731C5.97362 5.01675 6.28 4.85291 6.61358 4.78649C6.94716 4.72007 7.29292 4.75407 7.60717 4.88417C7.92142 5.01428 8.19004 5.23465 8.37905 5.51744C8.56806 5.80021 8.66899 6.13269 8.66904 6.47282C8.66909 6.69867 8.62464 6.9223 8.53825 7.13096C8.45186 7.33963 8.32524 7.52923 8.16559 7.68895C8.00593 7.84868 7.81637 7.97539 7.60773 8.06185C7.39911 8.14831 7.17551 8.19283 6.94968 8.19287ZM8.43135 19.0414H5.46491V9.49742H8.43135V19.0414ZM21.0183 2.00136H3.97582C3.58901 1.997 3.21626 2.14639 2.93953 2.4167C2.6628 2.68702 2.50472 3.05615 2.5 3.44297V20.5568C2.50456 20.9438 2.66255 21.3131 2.93927 21.5838C3.21599 21.8544 3.58881 22.0041 3.97582 21.9999H21.0183C21.406 22.0048 21.7799 21.8555 22.0578 21.5849C22.3355 21.3144 22.4945 20.9445 22.5 20.5568V3.44174C22.4944 3.05414 22.3352 2.6846 22.0575 2.41429C21.7797 2.14398 21.4059 1.99502 21.0183 2.00013\" fill=\"white\"></path> </svg>",
            }}
          />
        </a>
        <a href="https://www.youtube.com/@nacaosaudeapp" aria-label="YouTube" className="social-icon">
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<svg id=\"I66:769;19:371\" layer-name=\"YouTube (icon — Colour)\" width=\"24\" height=\"16\" viewBox=\"0 0 24 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"youtube-icon\" style=\"width: 23px; height: 16px\"> <path d=\"M12.462 15.979L7.76195 15.8922C6.24019 15.862 4.71465 15.9223 3.22273 15.6091C0.953169 15.1409 0.792386 12.8457 0.624143 10.9203C0.392322 8.21353 0.482067 5.45763 0.919544 2.77346C1.16651 1.26736 2.13845 0.36865 3.64149 0.270853C8.7154 -0.084062 13.8231 -0.0420008 18.8857 0.12358C19.4204 0.138759 19.9588 0.221723 20.486 0.316159C23.0884 0.77675 23.1519 3.37784 23.3206 5.56748C23.4889 7.7797 23.4178 10.0033 23.0962 12.2004C22.8383 14.0197 22.3447 15.5452 20.2616 15.6924C17.6516 15.8851 15.1016 16.0401 12.4843 15.9908C12.4844 15.979 12.4695 15.979 12.462 15.979ZM9.69881 11.3733C11.6657 10.2332 13.5949 9.112 15.5505 7.97947C13.58 6.83929 11.6543 5.71811 9.69881 4.58558V11.3733Z\" fill=\"white\"></path> </svg>",
            }}
          />
        </a>
      </div>
    </div>
  );
}

export default SocialIcons;
